/* global hillside_baseScreenReaderText */
/**
 * Theme functions file.
 *
 * Contains handlers for navigation and widget area.
 */


// Default mobile height
var headerHeight = 64;
var headerSticky = false;
var resizeTimer;
var height = window.innerHeight;


// For mobile stretch the menu to fill screen
function resizeWindow() {

    var e = document.querySelector(":root");
    window.innerWidth > e.clientWidth + 5 ? (e.classList.add("has-scrollbar"), e.style.setProperty("--scroll-bar", (window.innerWidth - e.clientWidth) + "px")) : e.style.setProperty("--scroll-bar", "--scroll-bar: 0px");

    // Height of menu on mobile for scrollbar addition
    var ddMenuHeight = (height - document.getElementById('header-inner').offsetHeight) + "px";
    document.getElementById('dropdownMenu').style.height = ddMenuHeight;
    

    headerHeight = document.getElementById('header-inner').offsetHeight;
    e.style.setProperty("--header-height", headerHeight+'px');
    headerSticky = document.getElementById('masthead').classList.contains("is-sticky");
    if(headerSticky) {       
        document.getElementById('page').style.paddingTop = headerHeight + "px";
    }
}

// Run resize once on page load to add height value
resizeWindow();

(function( $ ) {

    /*-----
    	------
    	Mobile Menu Menu Toggle
      ------
    	------*/
    var menuToggle, siteNavContain, dropdownToggle;

    menuToggle     = $('#site-nav-toggle');
    siteNavContain = $('#site-navigation');
    dropdownToggle = $('#site-navigation .dropdown-toggle');

    // On click of the menu toggle button
    menuToggle.on( 'click', function() {

        siteNavContain.toggleClass( 'toggled-on' );

        var isExpanded = siteNavContain.hasClass('toggled-on');

        if(isExpanded) {
            $('html').addClass('menu-expanded');
            menuToggle.attr( 'aria-expanded', 'true' );
            resizeWindow();
        } else {
            $('html').removeClass('menu-expanded');
            menuToggle.attr( 'aria-expanded', 'false' );
        }

        $( this ).attr( 'aria-expanded', siteNavContain.hasClass( 'toggled-on' ) );

        $('#section-toggle').on('click', function(){
            $(this).attr('aria-expanded', function (i, attr) {
                return attr == 'true' ? 'false' : 'true';
            });
        });
    });

    // On click of any dropdown toggle, top level pages are not clickable
    dropdownToggle.on( 'click', function() {
        var menuParent = $(this).parents('li');
        var isExpanded = menuParent.hasClass('toggled-on');

        menuParent.toggleClass('toggled-on');

        $(this).attr( 'aria-expanded', !isExpanded );

        resizeWindow();
    });

    /*-----
    	------
    	Sticky Menu Calculations and Logic
      ------
    	------*/

    // If the header has class is sticky
    if(document.getElementById('masthead').classList.contains('is-sticky')){

        headerSticky = true;
        var lastScrollTop = 0;

        // element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
        window.addEventListener("scroll", function(){ // or window.addEventListener("scroll"....
            var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
            if (st > lastScrollTop && st > headerHeight){
                $('html').addClass('scrolling-down').removeClass('scrolling-up');
            } else {
                $('html').addClass('scrolling-up').removeClass('scrolling-down');
            }
            lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
            if(lastScrollTop < 1) {
                $('html').removeClass('scrolling-up');
            };
        }, false);

    }

    // Recalculate menu height for mobile
    $(window).on('resize', function(e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            height = window.innerHeight;
            resizeWindow();
        }, 100);
    });

    /*-----
    	------
    	Additional Functionality
      ------
    	------*/

    // Hide things on click outside of the menu
    $(window).on('click', function() {
        $('html').removeClass('menu-expanded');
        $('button.menu-toggle, button.search-toggle').attr('aria-expanded', 'false');
        $('#site-navigation').removeClass('toggled-on');
    });

    // Prevent previous window click from happening when click is on menu items
    $('header#masthead #dropdownMenu, header#masthead .search, header#masthead .menu-toggle, header#masthead .search-toggle').click(function(event){
        event.stopPropagation();
    });

    // Add page menu hover for dark background on desktop
    $('#dropdownMenu').on('mouseenter', function() {
        if($('.menu-toggle:visible').length == 0) {
            $('html').addClass('menuhover');
        }
    });

    // Remove page menu hover for dark background on desktop
    $('#dropdownMenu').on('mouseleave', function() {
        if($('.menu-toggle:visible').length == 0) {
            $('html').removeClass('menuhover');
            $('#top-menu .toggled-on').removeClass('toggled-on').find('> button, > a').attr('aria-expanded', false);
        }
    });

    $('#top-menu > li').on('mouseenter', function(){
        if($('#site-nav-toggle:visible').length == 0) {
            $('#top-menu .toggled-on').removeClass('toggled-on').find('> button, > a').attr('aria-expanded', false);
        }
    });

    $('#site-navigation li.active-menu-item').parentsUntil('.hillside-mm').addClass('active-menu');

    $('#site-navigation [aria-current="page"], #section-navigation [aria-current="page"]').parents('li, ul').addClass('active-tree');

    /*----
        Deal with Tab looping
        ----*/
    // Tab to shut menu
    var allMenus = $('#dropdownMenu > ul > li, #utility-menu > ul > li');

    var firstMenuItems = [];
    var lastMenuItems = [];

    for (let i = 0; i < allMenus.length; i++) {
        let menuElements = $(allMenus[i]).find('a');
        firstMenuItems.push(menuElements[0]);
        lastMenuItems.push(menuElements[menuElements.length - 1]);
    }

    function closeMenu(element) {
        if($('#utility-navigation:visible')) {
            // tab event close menu focus on parent
            $(element).closest('li.hillside-mm').removeClass('toggled-on').children('button[aria-expanded="true"]').attr('aria-expanded', 'false').focus();
        }
    }

    $(lastMenuItems).on('keydown', function(e) {
        var keyCode = e.code || e.keyCode || e.which;
        if(keyCode == 9) {
            if(!e.shiftKey) {
                closeMenu(this);
                e.preventDefault();
            }
        }
    });

    // Shift-Tab to shut menu
    $(firstMenuItems).on('keydown', function(e) {
        var keyCode = e.code || e.keyCode || e.which;
        if(keyCode == 9) {
            if(e.shiftKey) {
                closeMenu(this);
                e.preventDefault();
            }
        }
    });

})( jQuery );

var globalHillside = {
    resize: function() {
        resizeWindow();
    }
}